<template>
  <div>
    <h1 class="case-detail-title">{{$t('editCase.sampleDetails')}}</h1>
    <div style="height: 560px;">
      <Form ref="sampleInfo" :model="sampleInfo" :label-width="140" :rules="ruleSample">
        <Row>
          <FormItem :label="$t('editCase.sampleNumber')" prop="sample_code" class="case-detail-form-item">
            <Input v-model="sampleInfo.sample_code" maxlength="20"></Input>
          </FormItem>
        </Row>
        <Row>
          <FormItem :label="$t('addNewCase.caseInfo.sampleType')" class="case-detail-form-item">
            <Input v-model="sampleInfo.sample_types" maxlength="50"></Input>
          </FormItem>
        </Row>
        <FormItem :label="$t('editCase.sampleDescription')" class="case-detail-form-item">
          <Input v-model="sampleInfo.sample_desc" maxlength="20"></Input>
        </FormItem>
        <FormItem :label="$t('addNewCase.caseInfo.analysisType')" class="case-detail-form-item">
          <Select v-model="sampleInfo.pathology_type">
            <Option v-for="item in fxffList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <div v-show="sampleInfo.create_part != undefined" style="text-align: center;">
          <img :src="sampleInfo.create_part" class="case-detail-material-img"/>
        </div>
        <div>
          <Row>
            <Col span="12">
              <Button type="primary" size="large" @click.native="samFormValidate('sampleInfo')">{{$t('editCase.saveSample')}}</Button>
            </Col>
            <Col span="12">
              <Button type="primary" size="large" @click.native="openUploadMaterials(sampleInfo.sample_id)" style="margin-left: 15px">{{$t('editCase.captureImage')}}</Button>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
    <div v-if="isShowMaterials">
      <Modal
        v-model="isShowMaterials"
        :closable="false"
        :styles="{top: '20px'}"
        :mask-closable="false"
        width = "870px"
        :title="$t('addNewCase.caseInfo.imageManagement')">
        <drawing-image-management :uploadList="uploadList" :editOrAdd="editMaterials" @getEditAddmaterialsList="getEditAddmaterialsList"></drawing-image-management>
        <div slot="footer">
          <Button type="primary" size="large"  style="width: 80px" @click="cancel()">{{$t('addNewCase.caseInfo.cancel')}}</Button>
          <Button type="primary" size="large"  style="width: 80px" @click="confirmMaterials()">{{$t('addNewCase.caseInfo.confirm')}}</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import DrawingImageManagement from '../addCase/DrawingImageManagement'
export default{
  props: ['fxffList', 'rslxList', 'sampleInfo'],
  components: { DrawingImageManagement },
  data () {
    return {
      materialsInfo: {
        editAddmaterialsList: [] // 修改取材图时，添加的取材图像
      },
      sampleId: '', // 样本id
      editMaterials: 'editMaterials', // 修改标识位
      isShowMaterials: false, // 是否显示取材图模态框
      uploadList: [], // 取材图像集合
      ruleSample: {
        sample_code: [
          { required: true, message: this.$t('editCase.sampleNumberTip'), trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.$vue = this
  },
  methods: {
    // 取消取材
    cancel () {
      this.isShowMaterials = false
    },
    // 确认提交取材图像
    async confirmMaterials () {
      if (this.materialsInfo.editAddmaterialsList.length !== 0) {
        // 将数据提交数据库
        let params = new URLSearchParams()
        params.append('materialsInfo', JSON.stringify(this.materialsInfo))
        params.append('sampleId', this.sampleId)
        params.append('caseId', this.sampleInfo.case_id)
        let suc = await this.$http.post(this.$vue.getData('ADD_MATERIALS_INFO_LIST_URL'), params)
        if (suc.data.result === '1') {
          this.$Notice.success({
            title: this.$t('caseList.messageNotification'),
            desc: this.$t('captureImage.successTip')
          })
          this.isShowMaterials = false
        }
      } else {
        this.$Notice.success({
          title: this.$t('caseList.messageNotification'),
          desc: this.$t('captureImage.addTip')
        })
        this.isShowMaterials = false
      }
      this.materialsInfo.editAddmaterialsList = []
    },
    // 添加取材图片预览图
    getEditAddmaterialsList (editAddmaterialsList) {
      this.materialsInfo.editAddmaterialsList = editAddmaterialsList
    },
    // 打开取材图像模态框
    async openUploadMaterials (sampleId) {
      this.sampleId = sampleId
      this.uploadList = []
      this.isShowMaterials = true
      let params = new URLSearchParams()
      params.append('sampleId', sampleId)
      // 根据样本id 获取取材图像信息
      let suc = await this.$http.post(this.$vue.getData('GET_MATERIALS_INFO_LIST_URL'), params)
      if (suc.data.result === '1') {
        if (suc.data.data !== null) {
          this.uploadList = suc.data.data
          this.$Notice.success({
            title: this.$t('caseList.messageNotification'),
            desc: this.$t('captureImage.existingTip')
          })
        } else {
          this.uploadList = []
        }
      }
    },
    samFormValidate (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveSample()
        } else {
          this.warning()
        }
      })
    },
    async saveSample () {
      let params = new URLSearchParams()
      let caseType = this.getCaseType()
      params.append('sampleInfo', JSON.stringify(this.sampleInfo))
      params.append('caseType', caseType)
      let suc = await this.$http.post(this.$vue.getData('GET_EDIT_CASE_SAMPLE_URL'), params)
      if (suc.data.result === '1') {
        this.$emit('reLoadSampleSlideList')
        this.success()
      } else {
        this.warning()
      }
    },
    /**
    * 方法描述:获取病例类型（细胞/组织)
    * @author JKD
    * @data 2019/2/1 16:23
    */
    getCaseType () {
      let pathologyType = this.sampleInfo.pathology_type // 获取分析类型
      let caseType = -1 // 病理类型
      if (pathologyType === '4' || pathologyType === '6' || pathologyType === '7') {
        caseType = 2
        return caseType
      } else {
        caseType = 1
        return caseType
      }
    },
    // 保存成功消息提醒
    success () {
      this.$Notice.success({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.saveTheSampleSuccessfully')
      })
    },
    // 保存失败消息提醒
    warning () {
      this.$Notice.error({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.failedToSaveSample')
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .case-detail-title
    font-weight bolder
    font-size 20px
    color #2d8cf0
    margin-bottom 24px
  .case-detail-form-item
    width 100%
    display inline-block
    padding-right 2%
  .case-detail-material-img
    width 120px
    height 120px
    border: 4px solid #42c2f3
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/caseDetail/Sample.vue